
<table
  class="table label-maps table-striped table-bordered table-hover table-responsive-sm table-responsive-md table-responsive-xl">
  <thead>
  <tr>
    <th class="justify-content-center">
      <div>
        <mat-checkbox value="null" class="align-middle" [color]="'primary'" [checked]="allSelected()" #allCheckbox
                      (change)="selectAll($event)"></mat-checkbox>
      </div>
    </th>
    <th>
      Nome
    </th>
    <th>
     Nome completo
    </th>
    <th style="width: 180px">
      CNPJ
    </th>
    <th>
      Ativa enquadramento
    </th>
    <th>
      Processamento automático
    </th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let carteira of allElements">
    <td>
      <div>
        <mat-checkbox [color]="'primary'" class="align-middle" [checked]="carteiraChecked(carteira)"
                      (change)="updateSelected($event, carteira)"></mat-checkbox>
      </div>
    </td>
    <td>{{carteira.nome}}</td>
    <td>{{carteira.nomeCompleto}}</td>
    <td class="text-nowrap">{{formatCnpj(carteira.cnpj)}}</td>
    <td class="pl-1 text-nowrap">{{carteira.ativa ? 'Sim' : 'Não'}}</td>
    <td class="pl-1 text-nowrap">{{carteira.auto ? 'Sim' : 'Não'}}</td>
  </tr>
  </tbody>
</table>

